import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class ConfigService extends CrudService {
  constructor() {
    super(API_RESOURCE.CONFIG)
  }

  batchUpdateConfigs = async (data) => {
    const response = await axios.put(`${this.resource}/batch`, data)

    return response.data
  }

  fetchAllConfigByCategory = async (category) => {
    const response = await axios.get(`${this.resource}/category/${category}`)

    return response.data
  }
  fetchConfigByType = async (type) => {
    const response = await axios.get(`${this.resource}/type/${type}`)
    return response.data
  }
  getDefaultUserByType = async (type) => {
    const response = await axios.get(`${this.resource}/defaultUser/${type}`)
    return response.data
  }

  updateTestingConfig = async (payload) => {
    const response = await axios.put(`${this.resource}/testing`, payload)
    return response.data
  }
}

export default ConfigService
